import { createContext, useContext, useEffect, useState } from "react";
import Globals from "../services/Globals";

interface GlobalContextProps {
    DevEnabled: boolean;
    DebugEnabled: boolean;
    Strings: string[];
}

const langFile = `${process.env.PUBLIC_URL}/lang.json`;
const GlobalContext = createContext<GlobalContextProps>({} as GlobalContextProps);

export const useGlobalContextContext = () => {
    const context = useContext(GlobalContext);
    if (context === undefined) {
        throw new Error("Custom context GlobalContext must be used within a CustomContextProvider");
    }
    return context;
};

export class OrientationValues {
    portraid: number;
    landscape: number;
}

export const GlobalContextProvider: React.FC = ({ children }) => {
    const [langJson, SetlangJson] = useState<any>();
    const [Strings, SetStrings] = useState<string[]>();

    let DevEnabled = Globals.GetParam('dev') ? true : false;
    let DebugEnabled = Globals.GetParam('debug') ? true : false;

    if (document.location.origin === "http://localhost:3000") {
        DevEnabled = true;
        DebugEnabled = true;
    }

    useEffect(() => {
        window.addEventListener('resize', onResize);

        (async function fetchConfig() {
            try {
                const resp = await (await fetch(langFile)).json();
                SetlangJson(resp);
                SetStrings(resp.Nederlands);
            } catch (e) {
                console.log(e);
            }
        }());
    }, []);

    function onResize() {
        console.log("resizing");
    }


    return (
        <GlobalContext.Provider value={{
            DevEnabled,
            DebugEnabled,
            Strings,
        }}>
            {children}
        </GlobalContext.Provider>
    );
};

export default GlobalContext;